import React from 'react'

const Toggle = ({ handleChange, isChecked }) => {
    return (
        <div className='toggle-container me-3'>
            <input type="checkbox"
                id='check'
                className='toggle'
                onChange={handleChange}
                checked={isChecked}
            />
            <label htmlFor="check">Dark M</label>
        </div>
    )
}

export default Toggle